module.exports = __webpack_public_path__ + "img/logo_rivha_pilates_footer.bc4575f4.png";